var map = {
	"./alastair-illustration.jpeg": 47,
	"./alastair-main.png": 48,
	"./coingossip-details.png": 49,
	"./coingossip-historical.png": 50,
	"./coingossip-main.png": 51,
	"./coingossip-popularity.png": 52,
	"./faveats-main.png": 53,
	"./faveats-map-selector.png": 54,
	"./logo-kpmgdv.png": 13,
	"./logo-ncs.svg": 14,
	"./logo-ufinity.png": 12,
	"./profilepic-jin.2023.jpg": 55,
	"./profilepic-jin.jpg": 15,
	"./smartmirror-hardware.jpeg": 56,
	"./smartmirror-main.png": 57,
	"./theresistance-cards.jpg": 58,
	"./theresistance-main.png": 59,
	"./thumb-alastair.png": 16,
	"./thumb-coingossip.png": 17,
	"./thumb-faveats.png": 18,
	"./thumb-smartmirror.png": 19,
	"./thumb-theresistance.png": 20
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46;